import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const withNavigateHook = (Component) => {
  return (props) => {
    const navigate = useNavigate();
    let params = useParams();
    let location = useLocation();
    // return <Component {...props} navigate={navigate} />;
    return <Component {...props} {...{location, navigate, params}} />;
  };
};

export default withNavigateHook;